module.exports = __webpack_public_path__ + "img/Barbados.9d969548.svg";